import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { MobCorpse } from "./mobCorpse";

export class FloatingRobotCorpse extends MobCorpse {
	static key = "FloatingRobotCorpse";
	constructor(xy: XY) {
		super(xy);
	}

	override getRepairableMobKey(): string | null {
		return "FloatingRobot";
	}

	static deserialize(data: any): FloatingRobotCorpse {
		const c = new FloatingRobotCorpse(deserializeXY(data.xy));
		c.restoreBaseFields(data);
		return c;
	}
}
